import * as I from "immutable";
import { createSelector } from "reselect";

import { Action, actionCreators } from "../actions";
import { notUndefined } from "../utils/any";

import { RootState } from ".";
import { getMonologUserId, getRooms } from "./roster";

type roomId = string;
type userId = string;

const initialStore = I.Record({
    typingByRoomId: I.Map<roomId, I.OrderedSet<userId>>(),
    rooms: I.Set<roomId>(),
})();
type Store = typeof initialStore;

export function update(store = initialStore, action: Action): Store {
    switch (action.type) {
        case actionCreators.onLogout.type:
        case actionCreators.onWrongToken.type: {
            return initialStore;
        }
        case actionCreators.onJoinedRoom.type: {
            const { roomId } = action.payload;
            let { rooms } = store;
            rooms = rooms.add(roomId);
            return store.merge({
                rooms,
            });
        }
        case actionCreators.onLeftRoom.type: {
            const { roomId } = action.payload;
            let { rooms } = store;
            rooms = rooms.delete(roomId);
            return store.merge({
                rooms,
            });
        }

        case actionCreators.onTyping.type: {
            const { room_id: roomId, user_ids: userIds } = action.payload;
            let { typingByRoomId } = store;
            if (userIds.length) {
                typingByRoomId = typingByRoomId.set(roomId, I.OrderedSet(userIds));
            } else {
                typingByRoomId = typingByRoomId.remove(roomId);
            }
            return store.merge({
                typingByRoomId,
            });
        }
        default: {
            return store;
        }
    }
}

export type OuterStore = { joinedRooms: Store };

export function getTypingByRoomId(store: RootState) {
    return store.joinedRooms.typingByRoomId;
}

export const getTypingWithoutMonologByRoomId = createSelector(
    getTypingByRoomId,
    getMonologUserId,
    (typingByRoomId, userId) =>
        userId ? typingByRoomId.map(x => x.remove(userId)) : typingByRoomId
);

export const getTypingNamesByRoomId = createSelector(
    getTypingWithoutMonologByRoomId,
    getRooms,
    (typingByRoomId, rooms) =>
        typingByRoomId.map(typing =>
            typing
                .map(userId => {
                    const room = rooms.find(x => x.userId === userId);
                    if (room && room.name) {
                        return room.name.split(" ")[0];
                    }
                    return undefined;
                })
                .filter(notUndefined)
        )
);

export function getTypingNames(store: RootState, roomId: string) {
    return getTypingNamesByRoomId(store).get(roomId, I.OrderedSet<string>());
}

// FIXME: delete unused
export function getJoinedRooms(store: RootState) {
    return store.joinedRooms.rooms;
}
